import { render } from "./UEBuildingContentEditView.vue?vue&type=template&id=37e246f5&scoped=true"
import script from "./UEBuildingContentEditView.vue?vue&type=script&lang=js"
export * from "./UEBuildingContentEditView.vue?vue&type=script&lang=js"

import "./UEBuildingContentEditView.vue?vue&type=style&index=0&id=37e246f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e246f5"]])

export default __exports__